export default {
  data () {
    return {

      }
    },
  methods: {
    betsOverview (period, currency, user = 0) {
      return this.$http.get(api+'api/v1/analytics/general/stats', {params: {period: period, currency: currency, user: user}});
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/analytic.js